import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Text from "./Text";
import CircularProgress from "@mui/material/CircularProgress";
import FormHelperText from "@mui/material/FormHelperText";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 2;
const BORDER_RADIUS = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP + BORDER_RADIUS,
      width: 250,
    },
    MenuListProps: {
      disablePadding: true,
    },
  },
};

// Define the props type for the component
interface DropdownProps {
  handleChange: any;
  selectedValue: any;
  label?: string;
  sx?: object;
  name?: string;
  size?: "small" | "medium";
  inputLabelSx?: object;
  placeholder?: string;
  loading?: boolean;
  options?: any[];
  errorMsg?: string | null;
  defaultValue?: string;
  [key: string]: any; // To allow additional props
}

const Dropdown: React.FC<DropdownProps> = ({
  handleChange,
  selectedValue,
  label = "",
  sx,
  name = "",
  size = "small",
  inputLabelSx,
  placeholder = "",
  loading = false,
  options = [],
  errorMsg = null,
  defaultValue = "",
  ...restProps
}) => {
  
  return (
    <FormControl fullWidth sx={{ ...sx }}>
      <InputLabel id="dropdown-label" sx={inputLabelSx}>
        {label}
      </InputLabel>
      <Select
        labelId="dropdown-label"
        id="dropdown"
        onChange={handleChange}
        value={defaultValue}
        MenuProps={MenuProps}
        {...restProps}
        IconComponent={ExpandMoreIcon}
        size={size}
        displayEmpty
        renderValue={(selected) =>
          !selected ? (
            placeholder
          ) : (
            <Text sx={{ fontSize: "0.875rem", textTransform: "capitalize",textAlign:"center" }}>
              {defaultValue}
            </Text>
          )
        }
      >
        <MenuItem disabled value={defaultValue}>
          <Text variant="body1" color="#a3a3a3">
            {placeholder}
          </Text>
        </MenuItem>
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={20} />
          </MenuItem>
        ) : (
          options.map((item, i) => (
            <MenuItem
              key={i}
              value={item}
              sx={{
                borderBottom: "1px solid #F4F4F6",
              }}
            >
              {item.categories}
            </MenuItem>
          ))
        )}
      </Select>
      {errorMsg && <FormHelperText error>{errorMsg}</FormHelperText>}
    </FormControl>
  );
};

export default Dropdown;
